// @flow

import {combineReducers} from 'redux';
import {
  GET_REQUEST, GET_SUCCESS,
  GET_FAILURE, UPDATE_REQUEST,
  UPDATE_SUCCESS, UPDATE_FAILURE,
  CREATE_REQUEST, CREATE_SUCCESS,
  CREATE_FAILURE, CLEAR,
} from '../actions/supplierView';
import {SET_DIRTY} from '../actions/form';

const active = (state = null, action) => {
  switch (action.type) {
    case GET_SUCCESS:
    case UPDATE_SUCCESS:
    case CREATE_SUCCESS:
      return action.supplier;
    case GET_REQUEST:
    case CLEAR:
      return null;
    default:
      return state;
  }
};

const error = (state = null, action) => {
  switch (action.type) {
    case GET_FAILURE:
    case UPDATE_FAILURE:
    case CREATE_FAILURE:
      return action.error;
    case GET_REQUEST:
    case GET_SUCCESS:
    case UPDATE_REQUEST:
    case UPDATE_SUCCESS:
    case CREATE_REQUEST:
    case CREATE_SUCCESS:
      return null;
    default:
      return state;
  }
};

const isDirty = (state = false, action) => {
  switch (action.type) {
    case SET_DIRTY:
      return action.form === 'supplier'
        ? action.dirty
        : state;
    case GET_SUCCESS:
    case UPDATE_SUCCESS:
    case CREATE_SUCCESS:
    case CLEAR:
      return false;
    default:
      return state;
  }
};

const isFetching = (state = false, action) => {
  switch (action.type) {
    case GET_REQUEST:
    case UPDATE_REQUEST:
    case CREATE_REQUEST:
      return true;
    case GET_SUCCESS:
    case GET_FAILURE:
    case UPDATE_SUCCESS:
    case UPDATE_FAILURE:
    case CREATE_SUCCESS:
    case CREATE_FAILURE:
      return false;
    default:
      return state;
  }
};

const supplierView = combineReducers({
  active,
  error,
  isDirty,
  isFetching,
});

export default supplierView;



// WEBPACK FOOTER //
// ./src/reducers/supplierView.js